import React from "react";
import { View } from "react-native";
import { ActivityIndicator } from "react-native-paper";
import { useTheme } from 'react-native-paper';


export function SplashScreen() {
  const { colors } = useTheme();
  return (
    <View style={{ padding: 10, backgroundColor: "white", height: "100%", justifyContent: 'center' }}>
      <ActivityIndicator animating={true} color={colors.primary} />
    </View>
  );
}
